import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { StepContent } from '../styled';
import FailureStepViewModel from './viewModel';
import {
  EnumErrorPrescriptionRenewal,
  ErrorPrescriptionRenewalResponse
} from '../../../../../../services/prescriptionRenewal.service';

interface FailureStepProps {
  errorType: ErrorPrescriptionRenewalResponse | null;
}

export default function FailureStep({ errorType }: FailureStepProps) {
  const { handleScheduleAppointment } = FailureStepViewModel();
  const buildErrorMessage = () => {
    switch (errorType?.data?.errorType) {
      case EnumErrorPrescriptionRenewal.DOCTOR_NOT_FOUND:
        return <>{errorType?.data?.message}</>;
      case EnumErrorPrescriptionRenewal.OYANA_NOT_FOUND:
        return <>{errorType?.data?.message}</>;
      case EnumErrorPrescriptionRenewal.NOT_ATTENDED_BY_DOCTOR:
        return <>{errorType?.data?.message}</>;
      case EnumErrorPrescriptionRenewal.NO_RECENT_ATTENDANCE:
        return (
          <>
            <Typography variant="body2R">
              Notamos que sua última consulta médica ocorreu há mais de 3 meses.
              <br />
              <br />
              Por determinação do Conselho Federal de Medicina (CFM), não é possível renovar receitas ou tratamentos sem
              reavaliação periódica.
              <br />
              <br />O prazo de 3 meses é o limite máximo de segurança da Oya. Para atualizar suas prescrições e exames com
              segurança, agende uma nova consulta.
            </Typography>
          </>
        );
      case EnumErrorPrescriptionRenewal.PENDING_REQUEST_ALREADY_EXISTS:
        return <>{errorType?.data?.message}</>;
      default:
        return <> Não foi possível processar sua solicitação.</>;
    }
  };

  return (
    <StepContent>
      <Typography variant="h3">Ops!</Typography>
      {buildErrorMessage()}

      <Link href={`${process.env.REACT_APP_SCHEDULE_CLIENT_URL}`}>
        <Button variant="contained" color="primary" fullWidth onClick={handleScheduleAppointment}>
          Agendar nova consulta
        </Button>
      </Link>
    </StepContent>
  );
}
